export default "__VITE_PUBLIC_ASSET__368c747f__"